import { isToday } from 'date-fns/isToday';
// import { isTomorrow } from 'date-fns/isTomorrow';
import { format } from 'date-fns/format';
import { useMemo } from 'react';

const getNextAvailableTime = (date: Date) => {
  const hasMinutes = date.getMinutes() !== 0;
  const dateFormat = hasMinutes ? 'h:mma' : 'ha';

  switch (true) {
    case isToday(date): {
      return format(date, `'Back at' ${dateFormat}`);
    }
    // case isTomorrow(date): {
    //   return format(date, `'Back tomorrow at' ${dateFormat}`);
    // }
    default: {
      return format(date, `'Back' EEE 'at' ${dateFormat}`);
    }
  }
};

export default function useNextAvailableTime(nextDate: string) {
  return useMemo(() => {
    const date = new Date(nextDate);
    return getNextAvailableTime(date);
  }, [nextDate]);
}
